import * as React from "react";
import TabLayout from "../components/TabLayout";
import { EmailInfo, useTabStore } from "../providers/TabProvider";
import Footer from "./components/Footer";
import { getEmailFingerprint, getInternetMessageId } from "../utils/emailFingerprint";

// import TextInsertion from "./components/TextInsertion";
// import { insertText } from "./taskpane";
interface AppProps {
  title: string;
}



const App: React.FC<AppProps> = () => {

  return (
    <>
      <>
        <TabLayout />
        <Footer />
        <EmailDataProvider />
      </>
    </>
  );
};

export default App;


function EmailDataProvider() {
  const setEmailData = useTabStore((s) => s.setEmailData);
  // const setStringQueries = useTabStore((s) => s.setStringQueries);
  // Get email data
  React.useEffect(() => {
    const item = Office.context.mailbox.item;
    if (!item) return;

    const formatRecipients = (recipients?: Office.EmailAddressDetails[]) =>
      recipients?.map((r) => ({
        name: r.displayName,
        email: r.emailAddress,
        recipient_type: r.recipientType,
      })) ?? [];

    const formatAttachments = (attachments?: Office.AttachmentDetails[]) =>
      attachments?.map((att) => ({
        id: att.id,
        name: att.name,
        size: att.size,
        contentType: att?.contentType || "",
        isInline: att.isInline,
      })) ?? [];

    const userInfo = (userInfo: Office.UserProfile) => ({
      type: userInfo.accountType,
      name: userInfo.displayName,
      email: userInfo.emailAddress,
    })

    const internetMessageId = getInternetMessageId();

    const buildEmailData = (content: string, fingerprint?: string): EmailInfo => ({
      subject: item.subject || "N/A",
      sender: item.from?.emailAddress || "Unknown",
      senderName: item.from?.displayName || "Unknown",
      cc: formatRecipients(item.cc),
      toRecipients: item.to?.map((r) => r.emailAddress).join(", ") || "N/A",
      receivedDate: item.dateTimeCreated
        ? new Date(item.dateTimeCreated).toLocaleString()
        : "N/A",
      attachments: formatAttachments(item.attachments),
      userInfo: userInfo(Office.context.mailbox.userProfile),
      rawContentText: content || "No content found",
      emailFingerprint: fingerprint,
      internetMessageId: internetMessageId,
    });

    item.body.getAsync("text", async (result) => {
      const body = result.status === Office.AsyncResultStatus.Succeeded
        ? result.value
        : `Failed to get body: ${result.error?.message || "Unknown error"}`;

      // Generate unique fingerprint for this email
      const fingerprint = await getEmailFingerprint({
        subject: item.subject || "",
        sender: item.from?.emailAddress || "",
        receivedDate: item.dateTimeCreated
          ? new Date(item.dateTimeCreated).toLocaleString()
          : "",
        rawContentText: body,
      });

      const emailData = buildEmailData(body, fingerprint);
      setEmailData(emailData);
      // console.log(emailData, "Email data with fingerprint:", fingerprint);
    });

    // const apiUrl = BaseApiUrlKey;
    // console.log("API base:", apiUrl);
  }, []);

  // React.useEffect(() => {
  //   const searchParams = new URLSearchParams(window.location.search);
  //   // Store the parameters you need, and then remove them from the URL

  //   const queries = queryNames.reduce((acc, param) => {
  //     const value = searchParams.get(param);
  //     if (value) {
  //       acc[param] = value;
  //     }
  //     return acc;
  //   }, {} as Record<typeof queryNames[number], string>);

  //   setStringQueries(queries);

  //   // Remove the query parameters from the URL
  //   // Get the current URL pathname
  //   const currentPath = window.location.pathname;

  //   // Replace the current history state with the new URL that has no search params
  //   // This removes the params without causing a page refresh.
  //   window.history.replaceState({}, '', `${currentPath}`);
  // }, []);

  return null;
}
